<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" color="primary" class="mr-3">
        <slot name="title"></slot>
      </v-btn>
    </template>
    <v-card class="modal-novo-anexo">
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="onClose" color="white">mdi-window-close</v-icon>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col class="modal-novo-anexo__form">
            <v-file-input
              accept="application/pdf, application/vnd.ms-excel"
              label="Anexo da ação"
              v-model="proposta.anexo"
              hide-details="auto"
              outlined
            >
            </v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-textarea
              v-model="proposta.descricao"
              label="Descrição da ação"
              name="descricao"
              type="text"
              outlined
              hide-details="auto"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="onClose">Fechar</v-btn>
        <v-btn
          color="info"
          outlined
          text
          @click="trocarMinuta"
          :disabled="!proposta.anexo"
          ><slot name="title"></slot
        ></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { municipioPropostaParcelasAnexoAPI } from "@/apis/proposta";

export default {
  name: "NovaAcao",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
      proposta: this.payload,
    };
  },
  watch: {
    payload: {
      handler(val) {
        this.proposta = val;
      },
      deep: true,
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    limpar() {
      this.proposta = {};
    },
    onClose() {
      this.dialog = false;
      this.limpar();
    },
    trocarMinuta() {
      this.setLoading(true);
      let formData = new FormData();

      formData.append("parcelaAnexo", this.proposta.anexo);
      formData.append("descricao", this.proposta.descricao);
      formData.append(
        "municipioPropostaParcelaId",
        this.payload.municipioPropostaParcelasId
      );

      municipioPropostaParcelasAnexoAPI
        .salvarAnexo(formData)
        .then((_) => {
          this.setLoading(false);
          this.$emit("reload");
          this.onClose();
        })
        .catch((err) => {
          this.$notification.error("Erro ao salvar anexo");
          console.log("Erro no salvar anexo ", err);
          this.setLoading(false);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-novo-anexo {
  &__form {
    display: flex;
    column-gap: 10px;
    padding: 10px;
    align-items: center;
    width: 100%;
    max-width: 600px;
    margin-left: auto;
  }
}
</style>
